import React from "react";
import { cvar } from "../../utils";

export interface PillProps {
  color: string;
  label: React.ReactNode;
}

/* Color-coded tag chip rendered everywhere — uses CSS variable names like
   "--green", "--amber", "--red", "--blue". */
export function Pill({ color, label }: PillProps): JSX.Element {
  return (
    <span
      className="pill"
      style={{
        background: `color-mix(in srgb, ${cvar(color)} 10%, transparent)`,
        color: cvar(color),
      }}
    >
      <span className="pdot" style={{ background: cvar(color) }} />
      {label}
    </span>
  );
}
